import china from '../../assets/geojson/china.json'
export const mapJson = {
  china: china
}
